import React from 'react';
import { Table } from 'react-bootstrap';


const KeyValueData = ({ data, children = null, numberFormat = null }) => {

    // add formatted value to data array
    const formattedData = data.map(item => {
        let formattedValue;
        switch (numberFormat) {
            case 'currency':
                formattedValue = `$${item.value.toLocaleString()}`;
                break;
            case 'percent':
                // handle 0 
                if (item.value === 0) {
                    formattedValue = '0%';
                } else if (item.value ==  100) {
                    formattedValue = '100%';
                } else {
                    formattedValue = `${item.value.toFixed(1)}%`;
                }
                break;
            default:
                formattedValue = item.value.toLocaleString();
        }
        return { ...item, formattedValue };
    });

    return (
        <div>
            {children}
            <Table striped>
                <thead>
                    <tr>
                        <th>Variable</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {formattedData.map((item, index) => (
                        <tr key={index}>
                            <td>{item.label}</td>
                            <td>{item.formattedValue}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}
export default KeyValueData;